<template>
    <div class="main">
        <img :src="require('../../assets/bg.jpg')" class="bg_main"/>
        <div class="mainBox">
            <div class="main_header">
                <div class="main_1">
                    <div class="main_1_left">
                        <h2> </h2>
                    </div>
                    <div class="main_1_right">
                        <div class="timeclear">
                            {{time}}
                            <el-date-picker
                            v-model="timeval"
                               format="yyyy-MM-dd hh:mm:ss"
                               type="date"
                               :clearable="false"
                              @change="onChange"
                               >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
            </div>    
            <div class="main_body">
                <div class="main_2">
                    <div class="main_2_1">
                        <ul class="textlist1">
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal='obj.today&&obj.today.plancnt?parseInt(obj.today.plancnt):0' :duration='4000'/>
                                        车
                                    </div>
                                    
                                    <p>今日已装货</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal='obj.today&&obj.today.finishcnt?parseInt(obj.today.finishcnt):0' :duration='4000'/>
                                        车
                                    </div>
                                    <p>今日已卸货</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0':endVal='obj.today&&obj.today.doingcnt?parseInt(obj.today.doingcnt):0' :duration='4000'/>
                                        车
                                    </div>
                                    <p>今日在途</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal='obj.today&&obj.today.finishweightsum?parseFloat(obj.today.finishweightsum):0' :duration='4000'  :decimals='2'/>
                                        吨
                                    </div>
                                    <p>今日运输重量</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="main_2_2">
                        <ul class="textlist2">
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal='obj.month&&obj.month.finishcnt?parseInt(obj.month.finishcnt):0' :duration='4000'/>
                                        车
                                    </div>
                                    <p>本月累计运输车次</p>
                                </div>
                            </li>
                            <li>
                                <div class="picture">
                                    <div class="img1">
                                        <img :src="require('../../assets/icon1.png')"/>
                                    </div>
                                    <div class="img2">
                                        <img :src="require('../../assets/icon2.png')"/>
                                    </div>
                                </div>
                                <div class="info">
                                    <div class="num">
                                        <CountTo :startVal='0' :endVal='obj.month&&obj.month.finishweightsum?parseFloat(obj.month.finishweightsum):0' :duration='4000' :decimals='2'/>
                                        吨
                                    </div>
                                    <p>本月累计运输重量</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="main_2_3"  @click="onshow5">
                        <ul class="textlist7">
                            <li>
                                <div class="title">
                                    <span class="green"></span>总车辆
                                </div>
                                <div class="info">
                                    <CountTo :startVal='0' :endVal='thinglist.length' :duration='4000'/>车
                                </div>
                            </li>
                            <li>
                                <div class="title">
                                    <span class="yellow"></span>运输中
                                </div>
                                <div class="info">
                                    <CountTo :startVal='0' :endVal='obj.today&&obj.today.doingcnt?parseInt(obj.today.doingcnt):0' :duration='4000'/>车
                                </div>
                            </li>
                            <li>
                                <div class="title">
                                    <span class="white"></span>闲置
                                </div>
                                <div class="info">
                                    <CountTo :startVal='0' :endVal='thinglistpup[4]?thinglistpup[4].value:0' :duration='4000'/>车
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="main_3">
                    <div class="main_3_1">
                        <div class="main_3_1_1">
                            <div class="title"><img :src="require('../../assets/title1.png')"/></div>
                            <div class="content">
                                <div id="main1" class="main"></div>
                            </div>
                        </div>
                        <div class="main_3_1_2" @click="onshow1">
                            <div class="title"><img :src="require('../../assets/title5.png')"/></div>
                            <div class="content">
                                <div class="tip">
                                    <img v-for="(item,index) in tasktotal.reduce((c, R) => parseInt(c)+ parseInt(R.totaltask), 0).toString().split('')" :src="require('../../assets/'+item+'.png')" />车
                                </div>
                                <ul class="gridlist1">
                                    <li v-for="(item,index) in tasktotal.slice(0,6)">
                                        <span>{{item.totaltask}} 车</span>
                                        <img :src="require('../../assets/task'+(index+1)+'.png')" />
                                        <p>
                                            {{item.placename}}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="main_3_2">
                        <div class="main_3_2_1">
                            <div class='wrap'>
                                <ul>
                                    <li @click="onMarkChange(1)">
                                        <img :src="require('../../assets/car_online1.png')" /><span>蓝色：正常</span>
                                    </li>
                                    <li @click="onMarkChange(2)">
                                        <img :src="require('../../assets/car_online2.png')" /><span>红色：超速</span>
                                    </li>
                                    <li @click="onMarkChange(3)">
                                        <img :src="require('../../assets/car_online3.png')" /><span>黄色：预警</span>
                                    </li>
                                    <li @click="onMarkChange(4)">
                                        <img :src="require('../../assets/place.png')" /><span>矿山、搅拌站</span>
                                    </li>
                                   <!-- <li @click="onMarkChange(5)">
                                        <img :src="require('../../assets/place3.png')" /><span>充电站</span>
                                    </li> -->
                                </ul>
                            </div>
                            <div class="container"  ref="qqMap" ></div>
                        </div>
                        <div class="main_3_2_2">
                            <div class="title"><img :src="require('../../assets/energy/title7.png')"/></div>
                            <div class="content">
                                <div id="main6" class="main"></div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="main_3_3">
                        
                        <div class="main_3_3_3 animate__animated animate__backInRight animate__delay-1s" @click="onshow3">
                            <div class="title"><img :src="require('../../assets/energy/title3.png')"/></div>
                            <div class="content">
                                <div class="tip">
                                    <p>车牌</p><p>时间</p><p>进度</p>
                                </div>
                                <div class="wrap">
                                    <vueSeamlessScroll :data="thinglist" :class-option="defaultOption" class="seamless-warp" v-if="thinglist.length>0">
                                    <ul class="textlist5">
                                        <li
                                        v-for="(item,index) in thinglist" :key="index"
                                        :class="'on'+(index+1)"
                                        >
                                            <div>{{item.thingregcode}}</div>
                                            <span>{{$formatime(item.modifytime, 'hms',)}}</span>
                                            <p
                                            :class="item.thingstatus==20?'n20':item.thingstatus==18?'n18':item.thingstatus==10?'n10':item.thingstatus==1?'n1':item.thingstatus==15?'n15':item.thingstatus==17?'n17':''"
                                            >
                                                <b></b>
                                                {{item.thingstatus==20?'卸车':item.thingstatus==18?'装车':item.thingstatus==10?'派单':item.thingstatus==1?'维修':item.thingstatus==15?'接单':item.thingstatus==17?'到达':item.thingstatus==5?'空闲':''}}
                                            </p>
                                        </li>
                                    </ul>
                                    </vueSeamlessScroll>
                                </div>
                            </div>
                        </div>
                        
                        <div class="main_3_3_2 animate__animated animate__backInRight animate__delay-1s" @click="onshow2">
                            <div class="title"><img :src="require('../../assets/energy/title4.png')"/></div>
                            <div class="content">
                                <div class="wrap">
                                    <vueSeamlessScroll :data="quantityList" :class-option="defaultOption" class="seamless-warp" v-if="quantityList.length>0">
                                    <ul class="textlist3">
                                        <li
                                        v-for="(item,index) in quantityList"
                                        :key="index"
                                        :class="'on'+(index+1)"
                                        >
                                        <div class="rank">{{item.staffname?item.staffname:'***'}}</div>
                                                <span>
                                                    {{item.thingregcode}}
                                                </span>
                                                <p >{{item.power}}%</p>
                                            
                                        </li>
                                    </ul>
                                    </vueSeamlessScroll>
                                </div>
                                
                            </div>
                        </div>
                        <div class="main_3_3_1 animate__animated animate__backInRight animate__delay-1s">
                            <div class="title"><img :src="require('../../assets/energy/title2.png')"/></div>
                            <div class="content">
                                <ul class="textlist6">
                                    <li >
                                        <div class="info">
                                            <div class="num">
                                                <CountTo :startVal='0' :endVal='obj.today&&obj.today.finishweightsum?parseInt(parseFloat(obj.today.finishweightsum)*0.3):0' :duration='4000'/>kg
                                            </div>
                                            <p>今日减少碳排放</p>
                                        </div>
                                        <img :src="require('../../assets/energy/icon5.png')" />
                                    </li>
                                    <li >
                                        <div class="info">
                                            <div class="num">
                                                <CountTo :startVal='0' :endVal='obj.total&&obj.total.finishweightsum?parseInt(parseFloat(obj.total.finishweightsum)*0.3):0' :duration='4000'/>kg
                                            </div>
                                            <p>累计减少碳排放</p>
                                        </div>
                                        <img :src="require('../../assets/energy/icon6.png')" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        <div class="mask_main" @click="onhide" v-if="show1==1||show2==1||show3==1||show4==1||show5==1"></div>
        <div :class="'transport_pup popup_main '+(show1==1?'animate__animated animate__backInLeft':show1==2?'animate__animated animate__backOutLeft':'')" 
        v-if='show1==1||show1==2'
        >
            <div class="popup_1">
                <div class="title"><img :src="require('../../assets/puptitle1.png')"/></div>
                <div class="content">
                    <div id="main3" class="main" v-if="show1==1"></div>
                </div>
            </div>
            <div class="popup_2">
                <div class="title"><img :src="require('../../assets/puptitle2.png')"/></div>
                <div class="content">
                    <div class="tip">
                        <p>发货单位</p><p>总运输车次</p><p>总卸车</p>
                    </div>
                    <div class="wrap">
                        
                        <vueSeamlessScroll :data="tasktotal" :class-option="defaultOption1" class="seamless-warp" v-if='tasktotal.length>0'>
                        <ul class="puplist">
                            <li
                            v-for="(item,index) in tasktotal" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div>{{item.placename}}</div>
                                <span>{{item.totaltask}}车</span>
                                <p>
                                    {{item.totalfinishweight}}吨
                                </p>
                            </li>
                        </ul>
                        </vueSeamlessScroll>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'transport_pup popup_main '+(show2==1?'animate__animated animate__backInRight':show2==2?'animate__animated animate__backOutRight':'')" v-if='show2==1||show2==2'>
            <div class="energy_1">
                <div class="title"><img :src="require('../../assets/energy/puptitle8.png')"/></div>
                <div class="content">
                    <div class="tip">
                        <p>车辆序号</p><p>车牌</p><p>司机姓名</p><p>司机电话</p><p>上一次充/换电时间</p><p>车辆剩余电量</p>
                    </div>
                    <div class="wrap">
                        <vueSeamlessScroll :data="quantityList" :class-option="defaultOption1" class="seamless-warp" v-if="quantityList.length>0">
                        <ul class="puplist energypup">
                            <li
                            v-for="(item,index) in quantityList" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div class="index">{{index+1}}</div>
                                <div class="thingregcode">{{item.thingregcode}}</div>
                                <div class="staffname">{{item.staffname?item.staffname:'**'}}</div>
                                <div class="tel">{{item.staffmobile?item.staffmobile:'***********'}}</div>
                                <div class="time">{{item.prevdate}}</div>
                                <div :class="'num '+item.power<30?'red':item.power>50?'green':'yellow'">
                                    {{item.power}}%
                                </div>
                            </li>
                        </ul>
                        </vueSeamlessScroll>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'state_pup popup_main '+(show3==1?'animate__animated animate__backInRight':show3==2?'animate__animated animate__backOutRight':'')" v-if='show3==1||show3==2' >
            <div class="state_1">
                <div class="title"><img :src="require('../../assets/puptitle5.png')"/></div>
            </div>
            <div class="state_2">
                <div class="state_2_1">
                    <div class="content">
                        <div id="main5" class="main" v-if="show3==1"></div>
                    </div>
                    <div class="bottom">
                        <div class="total">设备总数量：{{thinglist.length}}台</div>
                        <ul>
                            <li v-for="(item,index) in thinglistpup" :key="index" :class="'on'+(index+1)">
                                <img :src="item.img"/><p>{{item.name}}：{{item.value}}辆</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="state_2_2">
                    <div class="content">
                        <div class="tip">
                            <p>车牌</p><p>时间</p><p>进度</p>
                        </div>
                        <div class="wrap">
                            <vueSeamlessScroll :data="thinglist" :class-option="defaultOption1" class="seamless-warp" v-if="thinglist.length>0">
                            <ul class="puplist">
                                <li
                                v-for="(item,index) in thinglist" :key="index"
                                :class="'on'+(index+1)"
                                >
                                    <div>{{item.thingregcode}}</div>
                                    <span>{{$formatime(item.modifytime, 'hms',)}}</span>
                                    <p
                                    :class="item.thingstatus==20?'n20':item.thingstatus==18?'n18':item.thingstatus==10?'n10':item.thingstatus==1?'n1':item.thingstatus==15?'n15':item.thingstatus==17?'n17':''"
                                    >
                                        <b></b>
                                        {{item.thingstatus==20?'卸车':item.thingstatus==18?'装车':item.thingstatus==10?'派单':item.thingstatus==1?'维修':item.thingstatus==15?'接单':item.thingstatus==17?'到达':item.thingstatus==5?'空闲':''}}
                                    </p>
                                </li>
                            </ul>
                            </vueSeamlessScroll>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div :class="'transport_pup popup_main '+(show4==1?'animate__animated animate__backInLeft':show4==2?'animate__animated animate__backOutLeft':'')"
        v-if='show4==1||show4==2'
        >
            <div class="popup_1 charging_1">
                <div class="title"><img :src="require('../../assets/puptitle6.png')"/></div>
                <div class="content">
                    <ul class="puplist1">
                        <li
                        v-for="(item,index) in showObj4.list1" :key="index"
                        :class="'on'+(index+1)"
                        >
                            <div class="infoLeft">
                                <img :src="require('../../assets/charge'+(item.status=='0'?'3':item.status=='1'?'1':'2')+'.png')"/>
                                <p>
                                    {{item.status=="0"?'离线':item.status=="1"?'空闲':item.status=="2"?'已插枪':item.status=="3"?'充电中':item.status=="4"?'预约锁定':''}}
                                </p>
                            </div>
                            <div class="infoRight">
                                <div class="name">
                                    <i>{{item.power>10?'快':'慢'}}</i>{{item.title}}
                                </div>
                                <div class="id">枪编码{{item.connectorid}}</div>
                                <div class="power">最大功率{{item.power}}KW</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="popup_2 charging_2">
                <div class="title"><img :src="require('../../assets/puptitle7.png')"/></div>
                <div class="content">
                    <div class="tip">
                        <p>收费时段</p><p>优惠价(元/度)</p><p>电费</p><p>服务费</p>
                    </div>
                    <div class="wrap">
                        <ul class="puplist">
                            <li
                            v-for="(item,index) in showObj4.list" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div>{{item.time}}</div>
                                <span>{{item.total}}</span>
                                <p>
                                    {{item.electricity}}
                                </p>
                                <p>
                                    {{item.service}}
                                </p>
                            </li>
                            <li
                            v-for="(item,index) in showObj4.list" :key="index"
                            :class="'on'+(index+1)"
                            >
                                <div>{{item.time}}</div>
                                <span>{{item.total}}</span>
                                <p>
                                    {{item.electricity}}
                                </p>
                                <p>
                                    {{item.service}}
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'state_pup popup_main '+(show5==1?'animate__animated animate__backInRight':show5==2?'animate__animated animate__backOutRight':'')" v-if='show5==1||show5==2' >
            <div class="state_1">
                <div class="title"><img :src="require('../../assets/puptitle8.png')"/></div>
            </div>
            <div class="total_2">
                <div class="total_2_1">
                    <span :class="totalactive=='0'?'on':''" @click="gettotal('0')">全部车辆</span>
                    <span :class="totalactive=='1'?'on':''" @click="gettotal('1')">油卡</span>
                    <span :class="totalactive=='2'?'on':''" @click="gettotal('2')">电卡</span>
                </div>
                <div class="total_2_2">
                    <div class="item" v-for="(item,index) in totallist" :key="index">
                        <div class="wrap1">
                           <img :src="item.img" /> 
                        </div>
                        <div class="wrap2" v-if="totalobj">
                            <span>{{item.title}}</span>
                            <p>{{totalobj[item.filed][item.cntfiled]}}车</p>
                            <p>{{totalobj[item.filed][item.weightdiled]}}吨</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Qs from 'qs';
    import CountTo from 'vue-count-to';
    import vueSeamlessScroll from "vue-seamless-scroll";
    import {
        Toast
    } from 'vant';
    export default {
        name: '',
        components: {
            CountTo,
            vueSeamlessScroll,
        },
        computed: {

        },
        data() {
            return {
                mapTilesLoaded: false, // 添加标记，记录地图瓦片是否已加载完成
                obj: '',
                //汇总弹窗
                totalobj:'',
                totalactive:'0',
                totallist:[
                    {title:'今日',filed:'today',cntfiled:'finishcnt',weightdiled:'finishweightsum',img:require('../../assets/total1.png')},
                    {title:'本月',filed:'month',cntfiled:'finishcnt',weightdiled:'finishweightsum',img:require('../../assets/total2.png')},
                    {title:'本年',filed:'year',cntfiled:'finishcnt',weightdiled:'finishweightsum',img:require('../../assets/total3.png')},
                    {title:'累计',filed:'total',cntfiled:'finishcnt',weightdiled:'finishweightsum',img:require('../../assets/total4.png')}
                ],
                widths: window.screen.width,
                main1Chart: null,
                main3Chart: null,
                main4Chart: null,
                main5Chart: null,
                main6Chart: null,
                //时间
                time: this.$formatime(new Date().getTime(), 'ymdhms', 'now'),
                timeval: '',
                list: [],
                listtotal: [],
                thinglist: [],
                quantityList:[],
                thinglistpup:[],
                vehiclecnt:0,
                tasktotal:[],
                
                //地图
                // markerArr: [],
                marker: [],
                infoWindow: [],
                map: null,
                bounds: new TMap.LatLngBounds(),
                speednum: 0,
                maplist:[],
                addlist:[],
                addlist1:[],
                maplist1:[],//充电站
                //时间
                timer: null,
                //滚动
                defaultOption: {
                    step: 0.3,
                    limitMoveNum: 6,
                    // singleHeight: 20,
                    waitTime: 2000,
                    hoverStop: true,
                    // navigation:true,
                    openTouch: true,
                    switchSingleStep: true
                },
                defaultOption1: {
                    step: 0.3,
                    limitMoveNum: 9,
                    // singleHeight: 20,
                    waitTime: 2000,
                    hoverStop: true,
                    // navigation:true,
                    openTouch: true,
                    switchSingleStep: true
                },
                isroll: true,
                show1:0,
                show2:0,
                show3:0,
                show4:0,
                show5:0,
                showObj4:{
                    list:[],
                    list1:[],
                },
                //切换mark
                marktype:'all',
            }
        },
        created() {
            
        },

        mounted() {
            this.initMap();
            var that = this;
            window.addEventListener("resize", () => {
                that.widths = window.screen.width;
                clearInterval(that.timer);
                that.initMap(2);
                this.show1=0;
                this.show2=0;
                this.show3=0;
                this.show4=0;
                this.show5=0;
            })
        },
        methods: {
            onshow1(){
                this.show1=1;
                this.show2=0;
                this.show3=0;
                this.show4=0;
                this.show5=0;
                this.totalData(5);
            },
            onshow2(){
                this.show1=0;
                this.show2=1;
                this.show3=0;
                this.show4=0;
                this.show5=0;
                // this.getthingtotal(6);
            },
            onshow3(){
                this.show1=0;
                this.show2=0;
                this.show3=1;
                this.show4=0;
                this.show5=0;
                this.getthingtotal(5);
            },
            onshow4(e){
                var lists=e.geometry.data.EquipmentInfos;
                var objlist=[];
                this.show1=0;
                this.show2=0;
                this.show3=0;
                this.show4=1;
                this.show5=0;
                this.showObj4.list=this.organizeFees(e.geometry.data.ElectricityFee, e.geometry.data.ServiceFee);
                lists.forEach(items=>{
                    items.ConnectorInfos.forEach(item=>{
                        
                        objlist.push({
                            title:items.EquipmentName+item.ConnectorName,
                            status:item.Status,
                            connectorid:item.ConnectorID,
                            power:items.Power,
                        })
                    })
                })
                
                this.showObj4.list1=objlist;
            },
            onshow5(){
                this.show1=0;
                this.show2=0;
                this.show3=0;
                this.show4=0;
                this.show5=1;
                this.gettotal();
            },
            onhide(){
                if(this.show1==1){
                    this.show1=2;
                }else if(this.show2==1){
                    this.show2=2;
                }else if(this.show3==1){
                    this.show3=2;
                }else if(this.show4==1){
                    this.show4=2;
                }else if(this.show5==1){
                    this.show5=2;
                }
            },
            onChange(val) {
                this.timeval = this.$formatime(val.getTime(), 'ymd', 'now');
                this.time = this.$formatime(val.getTime(), 'ymdhms', 'now');
                this.initData(1);
            },
            goUrl(evt, type) {
                if(type=='3'){
                    this.$router.push({
                        path: '/sksjIndex',
                    });
                }else{
                    this.$router.push({
                        path: '/detail',
                        query: {
                            userid: type == 1 || type == 2 ? evt.userid : evt.geometry.properties.userid,
                            thingid: type == 1 || type == 2 ? evt.thingid : evt.geometry.id,
                            type: type ? type : 1,
                            thingpower:2
                        }
                    });
                }
            },
            settime(type) {
                let _this = this;
                var countdown = 20;
                if (this.timer) {
                    clearInterval(_this.timer);
                }
                this.timer = setInterval(function() {
                    
                    if (countdown) {
                        countdown--
                        if (!_this.timeval) {
                            _this.time = _this.$formatime(new Date().getTime(), 'ymdhms', 'now')
                        }
                    } else {
                        clearInterval(_this.timer);
                        if (!_this.timeval) {
                            _this.time = _this.$formatime(new Date().getTime(), 'ymdhms', 'now');
                        }
                        _this.initMap(1);
                    }
                }, 1000)
            },

            initMap(type) {
                if (this.$store.state.configdata) {
                    if (type != 1 && type != 2) {
                        var center = new TMap.LatLng(39.984104, 116.307503); //设置中心点坐标
                        this.map = new TMap.Map(this.$refs.qqMap, {
                            center: center,
                            mapStyleId: 'style3',
                            showControl: false,
                            baseMap: {
                                enable3D: true,
                                logoVisible: false,
                                type: 'vector',
                                features: [
                                    'base', 'building3d'
                                ],
                                visibleLayers: ['district', 'building']
                            }
                        });
                        
                        // 地图加载完成后再请求车辆数据
                        this.map.on('tilesloaded', () => {
                            // 只在第一次地图瓦片加载完成时执行
                            if (!this.mapTilesLoaded) {
                                this.mapTilesLoaded = true;
                                this.loadVehicleData(type);
                            }
                        });
                        
                        return; // 先返回让地图渲染
                    }
                    
                    // 如果地图已存在，直接加载车辆数据
                    this.loadVehicleData(type);
                }
            },
            
            loadVehicleData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_thing_super&m=vehicle_page',
                    data: {
                        rows: 1000,
                        thingpower:2
                    },
                    target: 'wuliu',
                    // islogin:true,
                    isheader:true,
                    success: res => {
                        var result = res.data;
                        const oldSet = new Set(this.maplist.map(({thingid,maplat,maplng}) => thingid + "/" + maplat + "/" + maplng));
                        const newSet = new Set(result.rows.map(({thingid,maplat,maplng}) => thingid + "/" + maplat + "/" + maplng));
                        const x = [], y = [],z=[];
                        for (let obj of this.maplist) {  //删除
                            (newSet.has(obj.thingid + "/" + obj.maplat +"/" + obj.maplng )? z : x).push(obj);
                        }
                        for (let obj of result.rows) { //新增
                            (oldSet.has(obj.thingid + "/" + obj.maplat +"/" + obj.maplng ) ? z : y).push(obj);
                        } 
                        for (var i = 0; i < x.length; i++) {
                            for (var j = 0; j < _this.marker.length; j++) {
                                if (_this.marker[j].id == x[i].thingid) {
                                    _this.marker[j].setMap(null);
                                    if(_this.infoWindow[j]){
                                        _this.infoWindow[j].setMap(null);
                                        _this.infoWindow.splice(j, 1);
                                    }
                                    
                                    _this.marker.splice(j, 1);
                                    
                                    j = j - 1;
                                }
                            }
                        }
                        
                        // 分批处理标记点，避免一次性创建过多标记导致卡顿
                        if (y.length > 0) {
                            const batchSize = 20; // 每批次处理的标记点数量
                            const processBatch = (startIndex) => {
                                const endIndex = Math.min(startIndex + batchSize, y.length);
                                const currentBatch = y.slice(startIndex, endIndex);
                                
                                _this.setQQMap(currentBatch, type);
                                
                                if (endIndex < y.length) {
                                    setTimeout(() => {
                                        processBatch(endIndex);
                                    }, 200); // 200ms后处理下一批
                                }
                            };
                            
                            processBatch(0);
                        }
                        
                        this.maplist=result.rows;
                        _this.settime()
                    },
                    complete: res => {
                        console.log(11)
                        _this.initData(type);
                    }
                }
                this.$getData(object);
            },
            onMarkChange(type){
                this.marktype=type;
                for (var j = 0; j < this.marker.length; j++) {
                    this.marker[j].setMap(null);
                    if(this.infoWindow[j]){
                        this.infoWindow[j].setMap(null);
                    }
                }
                this.marker=[];
                this.infoWindow=[];
                if(type<4){
                    this.setQQMap(this.maplist)
                }else if(type==5){
                    this.setQQMap(this.maplist1,10)
                }else{
                    this.setQQMap(this.addlist1,7);
                    const oldSet = new Set(this.addlist1.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                    const newSet = new Set(this.addlist.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                    const x = [], y = [],z=[];
                    for (let obj of this.addlist1) {  //删除
                        (newSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng )? z : x).push(obj);
                    }
                    for (let obj of this.addlist) { //新增
                        (oldSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng ) ? z : y).push(obj);
                    } 
                    for (var i = 0; i < x.length; i++) {
                        for (var j = 0; j < this.marker.length; j++) {
                            if (this.marker[j].id == x[i].placeid) {
                                this.marker[j].setMap(null);
                                this.marker.splice(j, 1);
                                j = j - 1;
                            }
                        }
                    }
                    this.setQQMap(y,8);
                    
                }
            },
            setQQMap(result, type) {
                // console.log(result)
                var list = [];
                var obj=''
                for (var i = 0; i < result.length; i++) {
                    var data = result[i];
                    if((type=='7'||type=='8')&&(this.marktype=='all'||this.marktype=='4')){
                        if(data.placelat>0&&data.placelng>0&&data.placeid>0){
                            obj = {
                                "id": data.placeid,
                                "styleId": 'marker',
                                "position": new TMap.LatLng(data.placelat, data.placelng),
                                "content": data.placename,
                                "userid": data.placeid,
                                'placeaddr':data.placeaddr,
                                "style":4,
                                "maxZoom":10,
                            }
                            list.push(obj);
                            this.createMarker(obj,type);
                        }
                    }else if(type=='9'||type=='10'||this.marktype=='5'){
                        if(data.StationLat>0&&data.StationLng>0&&data.StationID){
                            obj = {
                                "id": data.StationID,
                                "styleId": 'marker',
                                "position": new TMap.LatLng(data.StationLat, data.StationLng),
                                "content": data.placename,
                                "userid": data.StationID,
                                // 'placeaddr':data.placeaddr,
                                "style":4,
                                "maxZoom":10,
                                "data":data
                            }
                            list.push(obj);
                            this.createMarker(obj,type);
                        }
                    }else{
                        // console.log(data)
                       if(data.maplat>0&&data.maplng>0){
                           var warn=data.vehiclewarn?parseInt(data.vehiclewarn):0;
                           // var strobj=''
                           var strobj=this.$getPoliceType(warn,data);
                           if(this.marktype==2&&strobj.isred){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype==3&&strobj.isyellow){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype==1&&strobj.isblue){
                               
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }else if(this.marktype=='all'){
                               obj=this.setMapData(data,strobj)
                               list.push(obj);
                               this.createMarker(obj,type);
                           }
                       }  
                    }
                    
                }
                if(list.length>0){
                    if (type != 1&&type != 7&&type!='8'&&type!='9') {
                        this.showMarker(list);
                    }
                }
                

            },
            setMapData(data,strobj){
              var obj = {
                  "id": data.thingid,
                  "styleId": 'marker',
                  "position": new TMap.LatLng(data.maplat, data.maplng),
                  "rotate": 360 - Number(data.vehicledirection),
                  "content": data.thingregcode,
                  "speed": data.vehiclespeed,
                  "userid": data.userid,
                  "style":strobj.isred?2:strobj.isyellow?3:1,
                  'text':strobj.text,
                  "maxZoom":20,
              }
              return obj;
            },
            createMarker(data,type) {
                var _this = this;
                var mark = new TMap.MultiMarker({
                    id: data.id,
                    map: _this.map,
                    styles: {
                        "marker": new TMap.MarkerStyle({
                            "width": _this.setfontSize(30),
                            "height": _this.setfontSize(30),
                            "anchor": {
                                x: _this.setfontSize(30 / 2),
                                y: _this.setfontSize(30 / 2)
                            },
                            src: type==7?require('../../assets/place2.png'):type==8?require('../../assets/place.png'):type==9||type==10?require('../../assets/place3.png'):require('../../assets/car_online'+data.style+'.png'),
                            color: '#fff',
                            direction: 'bottom',
                            size: _this.setfontSize(14),
                            strokeColor: '#F69300',
                            rotate: type==7||type==8||type==9||type==10?0:data.rotate,
                        }),
                    },
                    geometries: [{
                        "id": data.id,
                        "styleId": 'marker',
                        "position": data.position,
                        "properties": {
                            "title": data.id,
                            "userid": data.userid
                        },
                        'maxZoom':data.maxZoom,
                        "content": type==7||type==8?data.content:'',
                        'data':data.data?data.data:'',
                    }]
                })
                
                if(type==7||type==8){
                    this.marker.push(mark);
                }else if(type==9||type==10){
                    this.marker.push(mark);
                    mark.on("click", this.onshow4);
                    var objtext=this.getstr(data.data);
                    // this.infoWindow.push(new TMap.InfoWindow({
                    //     map: _this.map,
                    //     enableCustom: true,
                    //     position: data.position,
                    //     zIndex:10,
                    //     offset: {
                    //         x: 0,
                    //         y: _this.setfontSize(-15)
                    //     }, //设置信息窗相对position偏移像素
                    //     content: "<div class='infowindow infowindow1'> <p>" + data.data.StationName + "</p><p style='margin:5px 0;'>当前" + this.addCurrentValues(data.data.ServiceFee,data.data.ElectricityFee) +
                    //         "元/度</p><p style='display:flex;justify-content: flex-end;'><span style='margin-right:20px'>快 "
                    //          + objtext.quickusable+'/'+objtext.quicktotal+ "</span><span>慢 " + objtext.smallusable+'/'+objtext.smalltotal+"</span></p></div>"
                    // }))
                    
                }else{
                    this.marker.push(mark);
                    mark.on("click", this.goUrl);
                    this.infoWindow.push(new TMap.InfoWindow({
                        map: _this.map,
                        enableCustom: true,
                        position: data.position,
                        zIndex:10,
                        offset: {
                            x: 0,
                            y: _this.setfontSize(-15)
                        }, //设置信息窗相对position偏移像素
                        content: "<div class='infowindow'> <p>" + data.content + "</p><p>" + data.speed +
                            "公里/小时</p></div>"
                    }))
                }
            },
            getstr(station){
                var obj={
                    total : 0,
                    usable : 0,
                    quicktotal : 0,
                    quickusable : 0,
                    smalltotal : 0,
                    smallusable : 0,
                };
                for (var equipment of station.EquipmentInfos) {
                  var setKey = ''
                  if (equipment.Power > 10) {
                    setKey = 'quick'
                  }else {
                    setKey = 'small'
                  }
                  for (var connecton of equipment.ConnectorInfos) {
                    if (connecton.Status == 1) {
                      obj.usable++;
                      obj[setKey+'usable'] ++;
                    }
                    obj.total++;
                    obj[setKey+'total'] ++;
                  }
                }
                return obj;
            },
            organizeFees(electricityData, serviceData) {
              const currentTime = new Date();
              const currentHour = currentTime.getHours();
              const currentMinute = currentTime.getMinutes();
              const electricityEntries = electricityData.split(";");
              const serviceEntries = serviceData.split(";");
              const resultArray = [];
              electricityEntries.forEach((electricityEntry, index) => {
                const serviceEntry = serviceEntries[index];
                if (electricityEntry && serviceEntry) {
                  const [electricityTime, electricityValue] = electricityEntry.split(",");
                  const [serviceTime, serviceValue] = serviceEntry.split(",");
            
                  if (electricityTime && electricityValue && serviceTime && serviceValue) {
                    const electricity = parseFloat(electricityValue) / 100;
                    const service = parseFloat(serviceValue) / 100;
                    const total = electricity + service;
                    const [startHour, startMinute] = electricityTime.split("~")[0].split(":").map(Number);
                    const [endHour, endMinute] = electricityTime.split("~")[1].split(":").map(Number);
                    const isCurrent = (currentHour > startHour || (currentHour === startHour && currentMinute >= startMinute)) &&
                      (currentHour < endHour || (currentHour === endHour && currentMinute <= endMinute));
                    resultArray.push({
                      electricity,
                      service,
                      total,
                      time: electricityTime,
                      current: isCurrent,
                    });
                  }
                }
              });
              // 根据 total 重新计算 tag
              const lowestTotal = Math.min(...resultArray.map(entry => entry.total));
              const highestTotal = Math.max(...resultArray.map(entry => entry.total));
              
              resultArray.forEach(entry => {
                if (entry.total == lowestTotal && resultArray.length > 1) {
                  entry.tag = 'min';
                }
                if (entry.total == highestTotal && resultArray.length > 1) {
                  entry.tag = 'max';
                }
              });
            
              return resultArray;
            },
            // 计算充电桩当前价格
            // addCurrentValues(str1, str2) {
            //       str1 = str1.replace('服务费', '');
            //       str2 = str2.replace('电费:', '');
            //       // 查找并相加当前时间段的两个数值
            //       const sum1 = this.findAndAddValue(str1);
            //       const sum2 = this.findAndAddValue(str2);
            //       // 将结果除以100并保留两位小数
            //       const result = ((sum1 + sum2) / 100).toFixed(2);
            //       return result;
            // },
            // 将字符串转换为对象
            parseString(str) {
              const obj = {};
              const segments = str.split(';');
              for (const segment of segments) {
                const [time, value] = segment.split(',');
                obj[time] = parseInt(value, 10);
              }
              return obj;
            },
            // 查找并相加当前时间段的两个数值
            findAndAddValue(str) {
              const obj = this.parseString(str);
              let sum = null;
              // 获取当前时间的小时和分钟
              const now = new Date();
              const currentHour = now.getHours();
              const currentMinute = now.getMinutes();          
              for (const [segment, value] of Object.entries(obj)) {
                const [start, end] = segment.split('~');
                const [startHour, startMinute] = start.split(':').map(Number);
                const [endHour, endMinute] = end.split(':').map(Number);
                        
                if (
                  (currentHour > startHour || (currentHour === startHour && currentMinute >= startMinute)) &&
                  (currentHour < endHour || (currentHour === endHour && currentMinute < endMinute))
                ) {
                  sum = value;
                  break;
                }
              }
              return sum;
            },
            showMarker(list) {
                //判断标注点是否在范围内
                var _this = this;
                list.forEach(function(item) {
                    //若坐标点不在范围内，扩大bounds范围
                    if (_this.bounds.isEmpty() || !_this.bounds.contains(item.position)) {
                        _this.bounds.extend(item.position);
                    }
                })
                //设置地图可视范围
                this.map.fitBounds(_this.bounds, {
                    padding: _this.setfontSize(100) // 自适应边距
                });
            },
            initData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        today: this.timeval,
                        totaltype: 'today,month,total',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.obj = result;
                        
                    },
                    complete: res => {

                        this.todayData(type);
                    }
                }
                this.$getData(object);
            },
            todayData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'taskfromid',
                        thingpower:2,
                        taskdate: this.timeval ? this.timeval : this.$formatime(new Date().getTime(), 'ymd', 'now')
                        
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.setChart1(result.rows, type);
                    },
                    complete: res => {
                        this.totalData(type);
                    }
                }
                this.$getData(object);
            },
            totalData(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'taskfromid',
                        thingpower:2,
                        taskdate:this.$formatime(new Date().getTime(), 'ym', 'now')
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.tasktotal=result.rows;
                        const oldSet = new Set(this.addlist.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                        const newSet = new Set(result.rows.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                        const x = [], y = [],z=[];
                        for (let obj of this.addlist) {  //删除
                            (newSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng )? z : x).push(obj);
                        }
                        for (let obj of result.rows) { //新增
                            (oldSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng ) ? z : y).push(obj);
                        } 
                        for (var i = 0; i < y.length; i++) {
                            for (var j = 0; j < _this.marker.length; j++) {
                                if (_this.marker[j].id == y[i].placeid) {
                                    _this.marker[j].setMap(null);
                                    _this.marker.splice(j, 1);
                                    j = j - 1;
                                }
                            }
                        }
                        _this.setQQMap(y,7); 
                        this.addlist1=result.rows;
                        if(type==5){
                            _this.setChart3(result.rows, type);
                        }
                        this.getPlace(type==1||type==5?_this.addlist:result.rows);
                    },
                    complete: res => {
                        if(type!=5){
                            this.getUser(type);
                        }
                    }
                }
                this.$getData(object);
            },
            getPlace(lists) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_group',
                    data: {
                        groupby: 'taskfromid',
                        thingpower:1,
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        const oldSet = new Set(lists.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                        const newSet = new Set(result.rows.map(({placeid,maplat,maplng}) => placeid + "/" + maplat + "/" + maplng));
                        const x = [], y = [],z=[];
                        for (let obj of lists) {  //删除
                            (newSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng )? z : x).push(obj);
                        }
                        for (let obj of result.rows) { //新增
                            (oldSet.has(obj.placeid + "/" + obj.maplat +"/" + obj.maplng ) ? z : y).push(obj);
                        } 
                        for (var i = 0; i < x.length; i++) {
                            for (var j = 0; j < _this.marker.length; j++) {
                                if (_this.marker[j].id == x[i].placeid) {
                                    _this.marker[j].setMap(null);
                                    // _this.infoWindow[j].setMap(null);
                                    _this.marker.splice(j, 1);
                                    // _this.infoWindow.splice(j, 1);
                                    j = j - 1;
                                }
                            }
                        }
                        _this.setQQMap(y,8); 
                        this.addlist=result.rows;
                    },
                    complete: res => {
                        // this.getCharge();
                    }
                }
                this.$getData(object);
            },
            getCharge(){
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=plat_station&m=station_page',
                    data: {},
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        const oldSet = new Set(this.maplist1.map(({StationID,StationLat,StationLng}) => StationID + "/" + StationLat + "/" + StationLng));
                        const newSet = new Set(result.StationInfos.map(({StationID,StationLat,StationLng}) => StationID + "/" + StationLat + "/" + StationLng));
                        const x = [], y = [],z=[];
                        for (let obj of this.maplist1) {  //删除
                            (newSet.has(obj.StationID + "/" + obj.StationLat +"/" + obj.StationLng )? z : x).push(obj);
                        }
                        for (let obj of result.StationInfos) { //新增
                            (oldSet.has(obj.StationID + "/" + obj.StationLat +"/" + obj.StationLng ) ? z : y).push(obj);
                        } 
                        for (var i = 0; i < x.length; i++) {
                            for (var j = 0; j < _this.marker.length; j++) {
                                if (_this.marker[j].id == x[i].StationID) {
                                    _this.marker[j].setMap(null);
                                    _this.infoWindow[j].setMap(null);
                                    _this.marker.splice(j, 1);
                                    _this.infoWindow.splice(j, 1);
                                    j = j - 1;
                                }
                            }
                        }
                        _this.setQQMap(y, 9);
                        this.maplist1=result.StationInfos
                    },
                    complete: res => {
                        
                    }
                }
                this.$getData(object);
            },
            getUser(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        totaltype: 'month6',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.setChart6(result,type);
                    },
                    complete: res => {
                        if(type!=5){
                            _this.getthingtotal(type);
                        }
                    }
                }
                this.$getData(object);
            },
            
            // getUsertotal(type) {
            //     var _this = this;
            //     let object = {
            //         url: 'd=wxapi&c=emp_task_super&m=task_group',
            //         data: {
            //             groupby: 'userid',
            //             rows: '20',
            //         },
            //         // islogin:true,
            //         target: 'wuliu',
            //         success: res => {
            //             var result = res.data;
            //             this.listtotal = result.rows;
                        
            //             if(type==6){
            //                 _this.setChart3(this.listtotal, type);
            //             }
            //         },
            //         complete: res => {
            //             if(type!=5){
            //                 _this.getthingtotal(type);
            //             }
            //         }
            //     }
            //     this.$getData(object);
            // },
            getthingtotal(type) {
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_thing_super&m=thing_page',
                    data: {
                        rows:'1000',
                        orderby: 'modifytime',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.thinglist = result.rows;
                        
                        var thingstatus18=0,thingstatus20=0,thingstatus15=0,thingstatus1=0,thingstatus5=0;
                        var d = 100
                        result.rows.forEach(item=>{
                            d -= (Math.round(Math.random() + 0) + 1)
                            item.num=d;
                            if(item.thingstatus==18){
                                thingstatus18++
                            }else if(item.thingstatus==20){
                                thingstatus20++
                            }else if(item.thingstatus==15){
                                thingstatus15++
                            }else if(item.thingstatus==1){
                                thingstatus1++
                            }else if(item.thingstatus==5){
                                thingstatus5++
                            }
                        })
                        _this.thinglistpup=[
                            { value: thingstatus18,itemStyle: {color:'#77F68C'}, name: '已装车',img:require('../../assets/thingstatus18.png')},
                            { value: thingstatus20,itemStyle: {color:'#FFDD43'}, name: '已卸货',img:require('../../assets/thingstatus20.png')},
                            { value: thingstatus15, itemStyle:{color:'#00B6EF'},name: '已接单',img:require('../../assets/thingstatus15.png')},
                            { value: thingstatus1, itemStyle:{color:'#F87575'},name: '维修',img:require('../../assets/thingstatus1.png')},
                            { value: thingstatus5, itemStyle:{color:'#fff'},name: '空闲',img:require('../../assets/thingstatus5.png')},
                        ]
                        if(type==5){
                            _this.setChart5(_this.thinglistpup,type) 
                        }
                        if(type==6){
                            _this.setChart3(result.rows, type);
                        }
                    },
                    complete: res => {
                        this.getQuantity();
                    }
                }
                this.$getData(object);
            },
            getQuantity(){
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_thing_super&m=factory_page',
                    data: {
                        rows:'1000',
                        orderby: 'modifytime',
                        thingpower:2
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        _this.quantityList = result.rows;
                    },
                    complete: res => {
                
                    }
                }
                this.$getData(object);
            },
            gettotal(type) {
                this.totalactive=type?type:'0';
                var _this = this;
                let object = {
                    url: 'd=wxapi&c=emp_task_super&m=task_total',
                    data: {
                        thingpower:type!='0'?type:'',
                        totaltype: 'today,month,year,total'
                    },
                    target: 'wuliu',
                    success: res => {
                        var result = res.data;
                        this.totalobj=result;
                    },
                    complete: res => {
            
                    }
                }
                this.$getData(object);
            },
            setfontSize(res) {
                const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body
                    .clientWidth;
                if (!clientWidth) return;
                let fontSize = clientWidth / 1920;
                return parseInt(res * fontSize);
            },
            setChart1(data,type,id) {
                if (data.length > 0) {
                    data = data.sort((a, b) => b.totaltask - a.totaltask)
                }
                var xdata = [], ydata = [];
                // 
                data.forEach(item => {
                    xdata.push(item.placename);
                    ydata.push(item.totaltask);
                })
                if (type == 1) {
                    this.main1Chart.setOption({
                        series: [{
                            data: ydata
                        }],
                        xAxis: {
                            data: xdata,
                        }
                    })
                    this.main1Chart.resize();
                } else if (type == 2) {
                    this.main1Chart.resize();
                } else {
                    this.main1Chart = this.$echarts.init(document.getElementById('main1'));
                    var option = {
                        grid: {
                            top: '10%',
                            left: '1%',
                            right: '2%',
                            bottom: '2%',
                            containLabel: true
                        },
                        toolbox: {
                            show: false,
                            orient: 'vertical',
                            left: 'right',
                            top: 'center',
                            feature: {
                                magicType: {
                                    show: true,
                                    type: ['line', 'bar']
                                },
                            }
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                            formatter: function (params) {
                                
                                var htmlStr = '';
                                htmlStr += '<div><span style="color:#000;">' + params[0].axisValue + '</span><br/> ';
                                htmlStr += '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:'+params[0].color.value+'"></span>';
                                htmlStr += '<span style="color:#000;margin-right:20px">' + params[0].seriesName + '</span><span style="color:#000;font-weight:bold;">' + params[0].value + ' 车</span></div>';
                                return  htmlStr
                            },
                        },
                        xAxis: {
                            type: 'category',
                            data: xdata,
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                    width: 0,
                                    type: "solid"
                                }
                            },
                            axisLabel: { //x轴文字的配置
                                show: true,
                                interval: 0,
                                // rotate:30,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: this.setfontSize(13)
                                },
                                formatter: function(value) //X轴的内容
                                {
                                    
                                    var ret = ""; //拼接加\n返回的类目项
                                    var max = 0; //每行显示的文字字数
                                    if(xdata.length>12){
                                        max = 1; //每行显示的文字字数
                                    }else if(xdata.length<=12&&xdata.length>10){
                                        max = 2; //每行显示的文字字数
                                    }else if(xdata.length<=10&&xdata.length>5){
                                        max = 3; //每行显示的文字字数
                                    }else{
                                        max = 4; //每行显示的文字字数
                                    }
                                    
                                    var val = value.length; //X轴内容的文字字数
                                    if(val>=13){
                                        value=value.slice(0,13)+'..';
                                        val = value.length;
                                    }
                                    
                                    var rowN = Math.ceil(val / max); //需要换的行数
                                    if (rowN > 1) //判断 如果字数大于2就换行
                                    {
                                        for (var i = 0; i < rowN; i++) {
                                            var temp = ""; //每次截取的字符串
                                            var start = i * max; //开始截取的位置
                                            var end = start + max; //结束截取的位置
                                            temp = value.substring(start, end) + "\n";
                                            ret += temp; //最终的字符串
                                        }
                                        return ret;
                                    } else {
                                        return value
                                    }
                                }
                            },
                        },
                        yAxis: {
                            type: 'value',
                            splitLine: { //分割线配置
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                }
                            },
                            axisLabel: { //
                                show: true,
                                textStyle: {
                                    color: "#aaa",
                                    fontSize: this.setfontSize(16)
                                }
                            },
                        },
                        series: [{
                            name: '运输车次',
                            data: ydata,
                            type: 'bar',
                            barMaxWidth: this.setfontSize(20),
                            itemStyle: {
                                color: {
                                    value:'rgba(246,147,0,1)',
                                    type: 'linear',
                                    x: 0, //右
                                    y: 0, //下
                                    x2: 0, //左
                                    y2: 1, //上
                                    colorStops: [{
                                            offset: 0,
                                            color: 'rgba(246,147,0,1)' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(246,147,0,0)' // 100% 处的颜色
                                        }
                                    ]
                                }
                            },
                            label: {
                                show: true,
                                // position: ['50%', '45%'], // 汉字位于上方
                                padding: 0, // 汉字距离柱状图间距
                                color: '#fff',
                                position: 'top',
                                fontSize: this.setfontSize(14),
                                formatter:"{c} 车",
                            },

                        }]
                    };
                    this.main1Chart.setOption(option);
                }
            },
            setChart3(items, type) {
                var xdata = [],
                    ydata = [];
                items.forEach((item, index) => {
                    if(index<=10){
                        if(type==5){
                            xdata.push(item.placename);
                            ydata.push(item.totaltask);
                        }else if(type==6){
                            xdata.push(item.thingregcode);
                            ydata.push(item.num);
                        }
                    } 
                })
                if (type == 1) {
                    this.main3Chart.setOption({
                        series: [{
                            data: ydata
                        }],
                        xAxis: {
                            data: xdata,
                        }
                    })
                    this.main3Chart.resize();
                } else if (type == 2) {
                    this.main3Chart.resize();
                } else {
                    if(type==5){
                        this.main3Chart = this.$echarts.init(document.getElementById('main3'));
                    }else if(type==6){
                        this.main4Chart = this.$echarts.init(document.getElementById('main4'));
                    }
                    
                    var option = {
                        grid: {
                            top: '6%',
                            left: '1%',
                            right: '4%',
                            bottom: '1%',
                            containLabel: true
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            },
                            formatter: function (params) {
                                
                                var htmlStr = '';
                                htmlStr += '<div><span style="color:#000;">' + params[0].axisValue + '</span><br/> ';
                                htmlStr += '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:'+params[0].color.value+'"></span>';
                                htmlStr += '<span style="color:#000;margin-right:20px">' + params[0].seriesName + '</span>';
                                htmlStr += '<span style="color:#000;font-weight:bold;">' + params[0].value +(type==5?" 车":" %")+'</span></div>';
                                return  htmlStr
                            },
                        },
                        //右侧提示
                        toolbox: {
                            show: false,
                            orient: 'vertical',
                            left: 'right',
                            top: 'center',
                            feature: {
                                magicType: {
                                    show: true,
                                    type: ['line', 'bar']
                                },
                            }
                        },
                        xAxis: [{
                            type: 'category',
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                    width: 0,
                                    type: "solid"
                                }
                            },
                            axisLabel: { //x轴文字的配置
                                show: true,
                                interval: 0,
                                rotate:30,
                                textStyle: {
                                    color: "#fff",
                                    fontSize: this.setfontSize(16)
                                },
                            },
                            data: xdata
                        }],
                        yAxis: [{
                            type: 'value',
                            splitLine: { //分割线配置
                                show: true,
                                lineStyle: {
                                    color: "rgba(255,255,255,0.1)",
                                }
                            },
                            axisLabel: { //
                                show: true,
                                textStyle: {
                                    color: "#aaa",
                                    fontSize: this.setfontSize(16)
                                }
                            },
                        }],
                        series: [{
                            name: type==5?'运输车次':type==6?'车辆电量':'',
                            data: ydata,
                            type: 'bar',
                            barMaxWidth: this.setfontSize(30),
                            itemStyle: {
                                color: {
                                    value:'rgba(246,147,0,1)',
                                    type: 'linear',
                                    x: 0, //右
                                    y: 0, //下
                                    x2: 0, //左
                                    y2: 1, //上
                                    colorStops: [{
                                            offset: 0,
                                            color: 'rgba(246,147,0,1)' // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(246,147,0,0)' // 100% 处的颜色
                                        }
                                    ]
                                }
                            },
                            label: {
                                show: true,
                                // position: ['50%', '45%'], // 汉字位于上方
                                padding: 0, // 汉字距离柱状图间距
                                color: '#fff',
                                position: 'top',
                                fontSize: this.setfontSize(14),
                                formatter:type==5?"{c} 车":type==6?"{c} %":'',
                                
                            },

                        }]

                    };
                    if(type==5){
                        this.main3Chart.setOption(option);
                    }else if(type==6){
                        this.main4Chart.setOption(option);
                    }
                    
                }
            },
            setChart5(data, type) {
                if (type == 1 || type == 3) {
                    this.main5Chart.setOption({
                        series: [{
                            data: data
                        }],
                    })
                    this.main5Chart.resize();
                } else if (type == 2) {
                    this.main5Chart.resize();
                } else {
                    this.main5Chart = this.$echarts.init(document.getElementById('main5'));
                    var option = {
                        tooltip: {
                            trigger: 'item',
                            formatter: function(params) {
                                var htmlStr = '';
                                htmlStr += '<div><span style="color:#000;">' + params.name + '</span><br/> ';
                                htmlStr +=
                                    '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:' +
                                    params.color + '"></span>';
                                htmlStr += '<span style="color:#000;margin-right:20px">' + params.seriesName +
                                    '</span><span style="color:#000;font-weight:bold;">' + params.value +
                                    ' 辆</span></div>';
                                return htmlStr
                            },
                        },
                        grid: {
                            // top: '2%',
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        series: [{
                            name: '车辆',
                            type: 'pie',
                            // radius:['80%','80%'],
                            center: ['50%', '50%'],
                            labelLine: {
                                "show": true,
                                "length": 1,
                                "length2": this.setfontSize(40)
                            },
                            avoidLabelOverlap: false,
                            label: {
                                // normal: {
            
                                // },
                                position: 'outer',
                                show: true,
                                alignTo: 'outer',
                                edgeDistance: '25%',
                                color: '#fff',
                                formatter: '{name|{b}}' + '\n\r' + '{num|{d}%}',
                                rich: {
                                    name: {
                                        fontSize: this.setfontSize(16),
                                        color: '#fff'
                                    },
                                    num: {
                                        fontSize: this.setfontSize(16),
                                        color: '#fff',
                                        lineHeight: this.setfontSize(30),
                                    },
                                }
                            },
                            bottom: 20,
                            top: 20,
                            data: data
                        }]
                    };
                    this.main5Chart.setOption(option);
                }
            },
            setChart6(items,type){
                var xdata=[],ydata=[];
                if(!this.main6Chart){
                    this.main6Chart = this.$echarts.init(document.getElementById('main6'));
                }
                items.month6.forEach((item,index)=>{
                    ydata.push((parseFloat(item.finishweightsum)*0.3).toFixed(2));
                    xdata.push(item.taskmonth);
                })
                if(type==1){
                    this.main6Chart.setOption({
                        series:[{data:ydata}],
                        xAxis:{data: xdata,}
                    })
                    this.main6Chart.resize();
                }else if(type==2){
                    this.main6Chart.resize();
                }else{
                    // this.main6Chart = this.$echarts.init(document.getElementById('main6'));
                    var option = {
                      xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: xdata,
                        axisLabel: { //x轴文字的配置
                            show: true,
                            interval:0,
                            // rotate:30,
                            textStyle: {
                                color: "#fff",
                                fontSize: this.setfontSize(14)
                            },
                        },
                      },
                      tooltip: {
                          trigger: 'axis',
                          axisPointer: {
                              type: 'shadow'
                          },
                          formatter: function(params) {
                              var htmlStr = '';
                              htmlStr += '<div><span style="color:#000;">' + params[0].name + '</span><br/> ';
                              htmlStr +=
                                  '<span style="width: 8px;height: 8px;margin-right:5px; display:inline-block;border-radius: 50%;background-color:' +
                                  params[0].color + '"></span>';
                              htmlStr += '<span style="color:#000;margin-right:20px">' + params[0]
                                  .seriesName + '</span><span style="color:#000;font-weight:bold;">' + params[
                                      0].value + ' kg</span></div>';
                              return htmlStr
                          },
                      },
                      yAxis: {
                          type: 'value',
                          splitLine: { //分割线配置
                              show: true,
                              lineStyle: {
                                  color: "rgba(255,255,255,0.1)",
                              }
                          },
                          axisLabel: { //
                              show: true,
                              textStyle: {
                                  color: "#aaa",
                                  fontSize: this.setfontSize(14)
                              }
                          },
                      },
                      grid: {
                          top: '20px',
                          left: '20px',
                          right: this.setfontSize(30),
                          bottom: this.setfontSize(5),
                          containLabel: true
                      },
                      series: [
                        {
                            name: '减排量',
                          data: ydata,
                          type: 'line',
                          smooth: true,
                          lineStyle: { // 设置线条的style等
                              normal: {
                                  color: '#45AA56', // 折线线条颜色:绿色
                              },
                          },
                          label:{
                              show: true,
                              color: '#fff',
                              fontSize: this.setfontSize(12),
                              formatter:"{c}kg",
                          },
                          areaStyle: {
                            color: {
                              type: 'linear',
                              x: 0,
                              y: 0,
                              x2: 0,
                              y2: 1,
                              colorStops: [{
                                    offset: 0,  color: 'rgba(69,170,86,0.6)',opacity: 0.2  // 100% 处的颜色
                              }, {
                                    offset: 1, color: 'rgba(69,170,86,0.6)' //   0% 处的颜色
                              }],
                              global: false // 缺省为 false
                            }
                          },
                        }
                      ]
                    };
                    this.main6Chart.setOption(option);
                }
            },
        },
        activated() {
            this.show1=0;this.show2=0;this.show3=0;this.show4=0;this.show5=0;
            this.list=[];
            this.listtotal= [];
            this.thinglist= [];
            this.thinglistpup=[];
            this.tasktotal=[];
        },
        destroyed() {
            console.log('进入销毁')
            if (this.timer) {
                console.log('开始销毁')
                clearInterval(this.timer);
            }
        },
        watch: {
            '$store.state.configdata'(val, oldVal) {
                if (!oldVal) {
                    this.initMap();
                }
            },
            '$route'(val, oldVal) {
                // console.log(val, oldVal)
                if (val.name=='energy'&&oldVal.name=='detail') {
                    console.log('重新开始1')
                    this.initMap(1);
                }else if (val.name=='energy'&&oldVal.name =='sksjindex') {
                    console.log('重新开始2')
                    this.initMap(1);
                }else if (val.name=='energy'&&oldVal.name =='homeIndex') {
                    console.log('重新开始2')
                    this.initMap(1);
                }else{
                    if (this.timer) {
                        console.log('开始销毁')
                        clearInterval(this.timer);
                    }
                }
                // if (val.name=='homeIndex'&&oldVal.name=='login') {
                //     // console.log('重新开始1')
                //     this.initMap(1);
                // }
            },
        },
    }
</script>
<style scoped lang="less">
    @import '../../style/css/variable.less';

    ::v-deep {
        // .bg_main {
        //     position: fixed;
        //     height: 100%;
        //     width: 100%;
        //     top: 0;
        //     right: 0;
        //     object-fit: fill;
        //     // background: rgba(23, 74, 156, 1);
        //     z-index: 999;
        // }
        .bg_main{
                position: fixed;
                height: 100%;
                width: 100%;
                    top: 0;
                    right: 0;
        }
        .mainBox {

            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            padding: 0 20px;
            background-size: 100% 100%;
            box-sizing: border-box;
            height: 100%;
            overflow: hidden;
            z-index: 999;
            .main_header{
                height: 8.8%;
                box-sizing: border-box;
               .main_1 {
                   position: relative;
                   height: 100%;
                   box-sizing: border-box;
                   .flex-center();
                   align-items: flex-start;
                   .main_1_left{
                       width:100%;height: 100%;
                       background: url('../../assets/tophjwl_bg.png') no-repeat center;
                       background-size: 100%;
                       // h2 {
                       //     display: block;
                       //     font-size: 40px;
                       //     color: #5AD2F8;
                       //     text-align: center;
                       //     margin-top: 10px;
                       // }
                       a{position: absolute;right: 620px;top:50%;transform: translate(0,-50%);display: block;
                         img{
                             width:30px;height:30px;display: block;
                         }  
                       }
                       
                   }
                   .main_1_right {
                       position: absolute;
                       right:0;
                       top:12px;
                       .flex-between();
                       flex-flow: column;
                       align-items: flex-end;
                       .timeclear{
                           position: relative;
                           font-size: 14px;
                           color: #86A9D6;
                           position: relative;
                           
                           text-align: right;
                           .el-date-editor{
                               position: absolute;
                               left:50%;
                               top:50%;
                               transform: translate(-50%,-50%);
                               input{
                                   font-size: 0;
                                   border:none;
                                   background: none;
                                   color: #B3B5BD;
                               }
                           }
                       }
                       .backHome{
                           a{
                               margin:32px 0 0 0;
                               .flex-start();font-size: 20px;color: #fff;align-items: center;
                               img{width: 24px;display: block;margin-right: 9px;}
                           }
                          
                       }
                   }
               } 
            }
            .main_body{
                height:89.36%;
                .main_2{
                    .flex-between();
                    align-items: flex-start;
                    height:15.86%;
                    .main_2_1{
                        width:50%;
                        height: 100%;
                    }
                    .main_2_2{
                        width:36.06%;
                        height:92.2%;
                        background: url(../../assets/main_2_2.png) no-repeat center;background-size:100% 100%;
                    }
                    .main_2_3{
                        width:12%;
                        height:92.2%;
                        background: url(../../assets/main_2_3.png) no-repeat center;background-size:100% 100%;
                        .flex-center();
                    }
                }
                .main_3{
                    height:84.14%;.flex-between();
                    .main_3_1{
                        .flex-between();flex-flow:column;
                        width: 23.19%;
                        height: 100%;
                        .main_3_1_1{
                            padding:9.16% 20px 2% 20px;
                            box-sizing: border-box;
                            width:100%;
                            height: 49.66%;
                            background: url(../../assets/main_3_1_1.png) no-repeat center;background-size:100% 100%;
                            .content{
                                padding:10px 0 0 0;
                            }
                        }
                        .main_3_1_2{
                            padding:4% 20px 1% 20px;
                            width:100%;
                            height: 48.88%;
                            background: url(../../assets/main_3_1_2.png) no-repeat center;background-size:100% 100%;
                            .tip{
                                .flex-center();height: 20%;color:#fff;font-size:20px;
                                img{display: block;width: 32px;margin-right: 5px;}
                            }
                            .content{height:90%;}
                        }
                    }
                    .main_3_2{
                        width: 59.84%;height: 100%;.flex-between();flex-flow:column;
                        .main_3_2_1{
                            width: 100%;
                            height: 61.6%;
                            background: rgba(23, 74, 156, 0.6);
                            box-shadow: inset 0px 0px 24px 1px #00B6EF;
                            border-radius: 0px 0px 0px 0px;
                            border: 1px solid #00B6EF;
                            box-sizing: border-box;
                            position: relative;
                            .wrap{
                                top:20px;
                                right:20px;position: absolute;z-index:9997;
                                background: linear-gradient(180deg, rgba(5,24,64,0.8) 0%, rgba(20,69,168,0.8) 100%);
                                box-shadow: inset 0px 0px 24px 1px #4482FF;border-radius: 5px;padding:20px;
                                ul{
                                    li{
                                        margin-bottom: 12px;
                                        .flex-start();
                                        img{display: block;width:20px;margin:0 8px 0 0;}
                                        span{
                                            font-size: 14px;color:#fff;
                                        }
                                        &:last-child{margin:0;}
                                    }
                                    
                                }
                            }
                        }
                        .main_3_2_2{
                            width: 100%;background: url(../../assets/energy/main_3_2_2.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            padding:15px 20px;height: 36.3%;
                        }
                    }
                    .main_3_3{
                        .flex-between();flex-flow:column;
                        width: 15.74%;
                        height: 100%;
                        .main_3_3_1{
                            padding:16px 10px;
                            width:100%;
                            height: 31.52%;
                            background: url(../../assets/main_3_3_1.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            .content{
                                .wrap{
                                    overflow: hidden;height:100%;
                                }
                                overflow: hidden;
                                padding: 10px 0 0 0;
                            }
                        }
                        .main_3_3_2{
                            
                            padding:16px 16px 10px 16px;
                            width:100%;
                            height: 26.73%;
                            background: url(../../assets/main_3_3_2.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            .title{height:14%;}
                            .content{
                                .wrap{
                                    overflow: hidden;height:100%;
                                }
                                height:86%;
                                padding: 10px 0 0 0;
                            }
                        }
                        .main_3_3_3{
                            padding:16px 20px;
                            width:100%;
                            height: 38.79%;
                            background: url(../../assets/main_3_3_3.png) no-repeat center;background-size:100% 100%;box-sizing: border-box;
                            .content{
                                .tip{
                                    height: 12%;.flex-between();
                                    p{font-size: 12px;color:#00B6EF}
                                }
                                .wrap{
                                    overflow: hidden;
                                    height: 88%;
                                }
                                
                            }
                        }
                    }
                }
            }
        .gridlist1{
            .flex-between();flex-wrap: wrap;height:80%;
            li{
                width:33.33%;height:50%;
                .flex-center();flex-flow: column;position: relative;
                span{
                    position: absolute;top:0;width:100%;left:0;text-align: center;
                    font-size: 18px;color: #fff;
                }
                img{
                    display: block;
                    width:88px;
                }
                p{
                    font-size: 14px;color: #fff;text-align: center;
                }
            }
        }
        
            
        .textlist1 {
            .flex-start();
            height: 100%;
            li {
                width: 280px;
                height: 100%;
                border-radius: 4px;
                padding: 0 0 0 ;
                box-sizing: border-box;
                .flex-start();
                .picture{
                    width:100px;height: 100px;
                    position: relative;
                    .img1{position: absolute;top: 0;left:0;width: 100%;height:100%;animation: roate 3s infinite linear;}
                    img{
                        display: block; width: 100%;height:100%;
                    }
                }
                .info{
                    margin:0 0 0 15px;
                    .flex-start();
                    flex-flow: column;
                    align-items: flex-start;
                    justify-content: space-around;
                    .num{
                        .flex-start();
                        color: #45E8F7;
                        font-size: 24px;
                        span {
                            margin:0 5px 0 0;
                            color: #45E8F7;
                            font-size: 24px;
                            font-weight: bold;
                        }
                    }
                    p {
                        margin-top: 5px;
                        display: block;
                        color: white;
                        font-size: 14px;
                    }
                }
                &:last-child{
                    width: 300px;
                }
            }
        }    
                

        .textlist2 {
            .flex-end();
            height: 100%;
            li {
                width: 50%;
                height: 100%;
                border-radius: 4px;
                padding: 0 0 0 ;
                box-sizing: border-box;
                .flex-center();
                .picture{
                    width:100px;height: 100px;
                    position: relative;
                    .img1{position: absolute;top: 0;left:0;width: 100%;height:100%;animation: roate 3s infinite linear;}
                    img{
                        display: block; width: 100%;height:100%;
                    }
                }
                .info{
                    margin:0 0 0 15px;
                    .flex-start();
                    flex-flow: column;
                    align-items: flex-start;
                    justify-content: space-around;
                    .num{
                        .flex-start();
                        color: #45E8F7;
                        font-size: 24px;
                        span {
                            margin:0 5px 0 0;
                            color: #45E8F7;
                            font-size: 24px;
                            font-weight: bold;
                        }
                    }
                    p {
                        margin-top: 5px;
                        display: block;
                        color: white;
                        font-size: 14px;
                    }
                }
                &:last-child{margin:0;}
            }
        }

        .textlist3 {
            height: 100%;
            li {
                margin-bottom: 5px;
                // height: 20%;
                box-sizing: border-box;
                .flex-center();
                // align-items: flex-end;
                
                width:100%;
                border-radius: 15px;
                padding: 0 10px;
                background: linear-gradient(90deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                .flex-between();
                
                // a{
                //     width:100%;
                //     border-radius: 15px;
                //     padding: 0 10px;
                //     background: linear-gradient(90deg, #1445A8 0%, rgba(20,69,168,0) 100%);
                //     .flex-between();
                    .rank {
                        .flex-start();
                        font-size: 14px;
                        flex: 1;
                        color: @white;
                    
                        b {
                            font-weight: normal;
                            display: block;
                            text-align: center;
                            width: 30px;
                        }
                    
                        img {
                            width: 30px;
                            display: block;
                        }
                    }
                    
                    span {
                        width: 76px;
                        height: 24px;
                        font-size: 14px;
                        color: @white;
                        .flex-center();
                    }
                    
                    p {
                        flex: 1;
                        font-size: 14px;
                        color: @white;
                        line-height: 24px;
                        text-align: right;
                    }
                // }
                &.on1{
                    // a{
                        background: linear-gradient(90deg, #F69300 0%, rgba(246,147,0,0) 100%);
                    // }
                }
                &.on2{
                    
                    // a{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    // }
                }
                &.on3{
                    
                    // a{
                        background: linear-gradient(90deg, #F6C44C 0%, rgba(246,147,0,0) 100%);
                    // }
                }
            }

        }

        .textlist4 {
            width:100%;
            height: 100%;
            li {
                box-sizing: border-box;
                margin-bottom:6px;
                a{
                    .flex-between();
                    .rank {
                        .flex-start();
                        font-size: 14px;
                        width:10.3%;height:26px;
                        
                        b {
                            border: 1px solid #00B6EF;border-radius: 50%;
                            font-weight: normal;
                            .flex-center();
                            width: 26px;height:26px;
                            color: @white;
                        }
                    
                        img {
                            width: 26px;
                            display: block;
                        }
                    }
                    
                    .username{
                        width: 65%;
                        height: 30px;
                        padding-right:14px;
                        b{
                            font-size: 14px;
                            color: #1856A4;
                            color: @white;
                            min-width:76px;
                            width:30%;
                            padding:0 0 0 10px;
                        }
                        .el-progress{
                            width:70%;
                            .el-progress-bar__outer{
                                height: 14px !important;
                            }
                        }
                        .flex-start();
                        
                        // justify-content: start;
                    }
                    
                    p {
                        width: 30%;
                        text-align: center;
                        font-size: 14px;
                        color: @white;
                        text-align: right;
                        flex: 1;
                    }
                }
                &.on1,&.on2,&.on3{
                    a{
                        .rank{
                            b{
                                border: none;
                            }
                            
                        }
                    }
                    
                    
                }
            }
        }

        .textlist5 {
            height: 100%;
            li {
                // a{
                    // height: 10%;
                    margin-bottom: 10px;
                    .flex-between();
                    
                    div {
                        font-size: 14px;
                        color: @white;
                        width: 40%;
                        text-align: left;
                    }
                    
                    span {
                        font-size: 14px;
                        color: @white;
                        width: 30%;
                        text-align: center;
                    }
                    
                    p {
                        font-size: 12px;
                        color: @white;
                        width: 30%;
                        text-align: right;
                        .flex-end();
                    
                        b {
                            width: 8px;
                            height: 8px;
                            margin-right: 8px;
                            background: white;
                        }
                    
                        &.n10 {
                            color: #55F8D7;
                    
                            b {
                                background: #55F8D7;
                            }
                        }
                    
                        &.n15 {
                            color: #F8B655;
                    
                            b {
                                background: #F8B655;
                            }
                        }
                    
                        &.n17 {
                            color: #00C734;
                    
                            b {
                                background: #00C734;
                            }
                        }
                    
                        &.n18 {
                            color: #0BB5EB;
                    
                            b {
                                background: #0BB5EB;
                            }
                        }
                    
                        &.n20 {
                            color: #44CA90;
                    
                            b {
                                background: #44CA90;
                            }
                        }
                    
                        &.n1 {
                            color: #E55563;
                    
                            b {
                                background: #E55563;
                            }
                        }
                    }
                // }
            }
        }
        .textlist6{
            height:100%;
            .flex-around();flex-wrap: wrap;
            li{
                width:50%;position: relative;
                img{
                    width:130px;height:68px;display: block;margin: 27px auto 0;
                }
                .info{
                    p{
                        font-size: 14px;color: #fff;text-align: center;margin-top: 8px;
                    }
                    .num{
                            font-size: 14px;color: #fff;.flex-center();align-items: flex-end;
                          span{
                              font-size: 30px;color: #fff;text-align: center;display: block;line-height: 1;
                          }  
                    }
                }
            }
        }
        .textlist7{
            li{
                .flex-start();
                .title{
                    .flex-start();font-size: 14px;color:@white;min-width: 70px;
                    span{
                        width: 0.2rem;height: 0.2rem;border-radius: 50%;margin-right: 10px;
                        &.green{
                            background: #77F68C;
                        }
                        &.yellow{
                            background: #F6C44C;
                        }
                        &.white{
                            background: #EBF2FB;
                        }
                    }
                }
                .info{
                    color:#45E8F7;font-size: 24px;
                    span{
                        color:#45E8F7;font-size: 24px;font-weight: bold;
                    }
                }
            }
        }
        .title {
            height: 10%;
            .flex-center();
            
            img{display: block;height:20px;width: auto;}
        }

        .content {
            height: 90%;
            .main {
                // padding: 1% 0;
                height: 100%;
                box-sizing: border-box;
            }
        }
        .container{
            width:100%;height:100%;
            a{display: none;}
            .logo-text{display: none;}
            canvas{opacity: 0.8 !important;}
        }
        .infowindow {
            padding: 0.2rem 0.2rem;
            // background: #4482FF;
            background: linear-gradient(180deg, rgba(5, 24, 64, 0.8) 0%, rgba(20, 69, 168, 0.8) 100%);
            box-shadow: inset 0px 0px 24px 1px #4482FF;
            border-radius: 5px;
            border-radius: 0.1rem;
            position: relative;

            p {
                font-size: 0.32rem;
                text-align: center;
                color: @white;
            }
            &.infowindow1{
                background: linear-gradient(180deg, rgba(5, 24, 64, 0.8) 0%, rgba(0,255,212, 0.8) 100%);
                box-shadow: inset 0px 0px 24px 1px #00FFD4;
                p{
                    text-align: left;
                }
            }
            // &::after{
            //     position: absolute;
            //     left:50%;bottom:0%;
            //     border-top: 0.2rem solid #000;
            //     border-right: 0.2rem solid transparent;
            //     border-left: 0.2rem solid transparent;
            //     content:''

            // }
            // &::before{
            //     content:'';
            //       position: absolute;
            //       left:50%;bottom:0%;
            //       border-top: 0.2rem solid #000;
            //       border-right: 0.2rem solid transparent;
            //         border-left: 0.2rem solid transparent;
            //         transform: translate(-50%,100%);
            // }
        }
    


        }

    }
</style>
